<template>
  <div class="homepage-wrapper">

    <div class="home-top-row">
      <div class="predmeti-zadaci-box section">
        <div class="predmeti-zadaci-title">{{ $t('page_1.row_1.box_1') }}</div>
        <div class="predmeti-zadaci-number">
          <div class="zadaci-number">{{ row_analytics.active_cases }}</div>
        </div>
        <div class="predmeti-zadaci-rast-row">
          <div class="predmeti-zadaci-rast-number rast-positive">+4%</div>
          <div class="predmeti-zadaci-rast-days">(30 dana)</div>
        </div>
      </div>
      <div class="predmeti-zadaci-box section">
        <div class="predmeti-zadaci-title">{{ $t('page_1.row_1.box_2') }}</div>
        <div class="predmeti-zadaci-number">
          <div class="zadaci-number">{{ row_analytics.archived_cases }}</div>
        </div>
        <div class="predmeti-zadaci-rast-row">
          <div class="predmeti-zadaci-rast-number rast-positive">+12%</div>
          <div class="predmeti-zadaci-rast-days">(30 dana)</div>
        </div>
      </div>
      <div class="predmeti-zadaci-box section">
        <div class="predmeti-zadaci-title">{{ $t('page_1.row_1.box_3') }}</div>
        <div class="predmeti-zadaci-number">
          <div class="zadaci-number">{{ row_analytics.important_events }}</div>
        </div>
        <div class="predmeti-zadaci-rast-row">
          <div class="predmeti-zadaci-rast-number rast-negative">-15%</div>
          <div class="predmeti-zadaci-rast-days">(30 dana)</div>
        </div>
      </div>
      <div class="predmeti-zadaci-box section">
        <div class="predmeti-zadaci-title">{{ $t('page_1.row_1.box_4') }}</div>
        <div class="predmeti-zadaci-number">
          <div class="zadaci-number">{{ row_analytics.upcoming_events }}</div>
        </div>
        <div class="predmeti-zadaci-rast-row">
          <div class="predmeti-zadaci-rast-number rast-positive">+20%</div>
          <div class="predmeti-zadaci-rast-days">(30 dana)</div>
        </div>
      </div>
      <div class="predmeti-zadaci-box section">
        <div class="predmeti-zadaci-title">{{ $t('page_1.row_1.box_5') }}</div>
        <div class="predmeti-zadaci-number">
          <div class="zadaci-number">{{ row_analytics.active_projects }}</div>
        </div>
        <div class="predmeti-zadaci-rast-row">
          <div class="predmeti-zadaci-rast-number rast-negative">-20%</div>
          <div class="predmeti-zadaci-rast-days">(30 dana)</div>
        </div>
      </div>
      <div class="predmeti-zadaci-box section">
        <div class="predmeti-zadaci-title">{{ $t('page_1.row_1.box_6') }}</div>
        <div class="predmeti-zadaci-number">
          <div class="zadaci-number">{{ row_analytics.archived_projects }}</div>
        </div>
        <div class="predmeti-zadaci-rast-row">
          <div class="predmeti-zadaci-rast-number rast-positive">+20%</div>
          <div class="predmeti-zadaci-rast-days">(30 dana)</div>
        </div>
      </div>
    </div>
    <div class="home-top-row">
      <div class="predmeti-zadaci-box oglasna">

        <div class="oglasna-row">
          <div v-if="!nema_oglasa" class="page-nav-prev" @click="prevOglas()">
            <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
              xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
              <defs>
                <clipPath id="ClipPath1018">
                  <path
                    d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                    fill="#ffffff"></path>
                </clipPath>
              </defs>
              <g>
                <g>
                  <g>
                    <path class="sssdf"
                      d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                      fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                      stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                      clip-path='url("#ClipPath1018")'></path>
                  </g>
                  <g>
                    <g>
                      <path class="sssdr" d="M37.11694,40.02775v0l-4.09639,-4.09664v0l4.09639,-4.09638v0" fill-opacity="0"
                        fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                        stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41" stroke-miterlimit="20" stroke-width="2">
                      </path>
                    </g>
                    <g>
                      <path d="M40.30245,40.02775v0l-4.09651,-4.09664v0l4.09651,-4.09638v0" fill-opacity="0"
                        fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                        stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20" stroke-width="2">
                      </path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div v-else style="width:10px;"></div>
          <div class="row-wrapp">
            <div class="oglasna-title">
              <span>{{ $t('page_1.row_2.title') }}</span>
              <router-link to="/bulletin-board" class="add-zadatak add-button add-plus"><svg
                  xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                  <g>
                    <g>
                      <path fill="#0acab1"
                        d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z" />
                    </g>
                  </g>
                </svg> </router-link>
            </div>


            <div class="moving-text-wrapper">
              <div class="bulletin-oglas">
                <div v-html="bulletin_array[bulletin_cntr].text" class="oglasna-text"></div>
                <div v-if="bulletin_array[bulletin_cntr].odvjetnik_bulletin_board_created_byToodvjetnik != undefined"
                  class="posted">
                  {{ $t('page_1.row_2.subtitle') }}:
                  {{ bulletin_array[bulletin_cntr].odvjetnik_bulletin_board_created_byToodvjetnik.ime }} {{
                    bulletin_array[bulletin_cntr].odvjetnik_bulletin_board_created_byToodvjetnik.prezime
                  }}
                  ({{ convertDate(bulletin_array[bulletin_cntr].created_date) }})
                </div>
                <div v-if="bulletin_array[bulletin_cntr].odvjetnik_bulletin_board_edited_byToodvjetnik != undefined"
                  class="posted">
                  {{ 'Uredio/la' }}:
                  {{ bulletin_array[bulletin_cntr].odvjetnik_bulletin_board_edited_byToodvjetnik.ime }} {{
                    bulletin_array[bulletin_cntr].odvjetnik_bulletin_board_edited_byToodvjetnik.prezime
                  }}
                </div>
              </div>
              <div class="bulletin-attachments-wrapper">
                <div @click="getAttachment(attachment.id, attachment.name)" class="bulletin-attachment"
                  v-for="(attachment, key) in bulletin_array[bulletin_cntr].attachments" :key="key">
                  <img class="bulletin-attachment-img" :src="returnFileType(attachment.name)" />
                  <div class="bulletin-attachment-name">{{ attachment.name.length > 45 ?
                    `${attachment.name.slice(0, 45)}...` : attachment.name
                  }}</div>
                </div>
              </div>
            </div>
            <!-- <div class="posted">Traje do:{{convertDate(bulletin_array[bulletin_cntr].end_date)}}</div> -->
          </div>


          <div v-if="!nema_oglasa" class="page-nav-next" @click="nextOglas()">
            <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
              xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
              <defs>
                <clipPath id="ClipPath1043">
                  <path
                    d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                    fill="#ffffff"></path>
                </clipPath>
              </defs>
              <g>
                <g>
                  <g>
                    <path class="sssdf"
                      d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                      fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                      stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                      clip-path='url("#ClipPath1043")'></path>
                  </g>
                  <g>
                    <g>
                      >
                      <path class="sssdr" d="M33.88303,40.02775v0l4.09651,-4.09664v0l-4.09651,-4.09638v0" fill-opacity="0"
                        fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                        stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41" stroke-miterlimit="20" stroke-width="2">
                      </path>
                    </g>
                    <g>
                      <path d="M30.69751,40.02775v0l4.09663,-4.09664v0l-4.09663,-4.09638v0" fill-opacity="0"
                        fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                        stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20" stroke-width="2">
                      </path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>

          <div v-else style="width:10px;"></div>

        </div>
        <div v-if="bulletin_array.length > 0" class="objava-counter">
          {{ bulletin_cntr + 1 }} / <span class="zadaci-amount">{{ bulletin_array.length }}</span>
        </div>

      </div>


    </div>
    <div class="home-columns-wrapper">
      <div class="two-columns-wrapper">
        <div class="home-first-column hc">
          <div class="aktualni-predmeti section">
            <div class="activity-navigation">
              <div class="activity-navigation-left">
                <div class="mab latest-activity-button">{{ $t('page_1.row_3.box_1.latest_activity') }} <img class="mab-icon"
                    src="@/assets/img/latest_activity.svg" /></div>
                <div class="snb small-navigation-button" @click="active_predmeti = true"
                  :class="[active_predmeti ? 'active' : '', 'aktualni-title']"><img class="mab-sm-icon mab-sm-first"
                    src="@/assets/img/cases_blue.svg" /></div>
                <div class="snb small-navigation-button" @click="active_predmeti = false"
                  :class="[!active_predmeti ? 'active' : '', 'aktualni-title']"><img class="mab-sm-icon"
                    src="@/assets/img/projects_blue.svg" /></div>
              </div>
              <div class="activity-navigation-right">
                <div class="mab my-cases-button"
                  @click="$store.state.view_cases_by_logged_person = true; $router.push('/cases')">
                  {{ $t('page_1.row_3.box_1.my_cases') }}<img class="mab-icon" src="@/assets/img/cases_blue.svg" /></div>
                <div class="mab my-projects-button"
                  @click="$store.state.view_cases_by_logged_person = true; $router.push('/projects')">
                  {{ $t('page_1.row_3.box_1.my_projects') }}<img class="mab-icon" src="@/assets/img/projects_blue.svg" />
                </div>
              </div>
            </div>

            <div v-if="fetching" class="center-spinner">
              <svg class="dot-spin" viewBox="0 0 50 50">
                <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
              </svg>
            </div>
            <div v-else class="cases-main-wrapper">
              <div class="cases-row row-title-row">
                <div class="cases-column cases-column1" style="opacity: 1 !important">
                  {{ active_predmeti ? $t('page_1.row_3.box_1.col_1') : $t('page_1.row_3.box_1.col_5') }}
                  <div class="downarrow"></div>
                </div>
                <div class="cases-column cases-column2" style="opacity: 1 !important; transform: none !important">
                  {{ $t('page_1.row_3.box_1.col_2') }}
                  <div class="downarrow"></div>
                </div>
                <div v-show="!active_predmeti" class="cases-column cases-column3">
                  {{ active_predmeti ? $t('page_1.row_3.box_1.col_3') : $t('page_1.row_3.box_1.col_6') }}
                  <div class="downarrow"></div>
                </div>
                <div class="cases-column cases-column4">
                  {{ active_predmeti ? $t('page_1.row_3.box_1.col_4') : $t('page_1.row_3.box_1.col_7') }}
                  <div class="downarrow"></div>
                </div>
              </div>
              <div v-if="active_predmeti" class="cases-inner-wrapper">
                <div v-for="(single_case, key) in homepage_cases" :key="key" class="cases-row">
                  <div class="cases-column cases-column1">
                    <router-link :to="'case/' + single_case.group_url + '/'">
                      <b>{{ single_case.broj_predmeta }}</b>
                    </router-link>
                  </div>
                  <div class="cases-column cases-column2">
                    {{ getDate(single_case.last_visited) }}
                  </div>

                  <div class="cases-column cases-column4">
                    <span>
                      <router-link :to="'case/' + single_case.group_url + '/'">{{ single_case.ime_predmeta }}
                      </router-link>
                    </span>
                  </div>
                </div>
              </div>
              <div v-else class="cases-inner-wrapper">
                <div v-for="(single_case, key) in homepage_projects" :key="key" class="cases-row">
                  <div class="cases-column cases-column1">
                    <router-link :to="'projects/' + single_case.group_url + '/'">
                      <b>{{ single_case.broj_projekta }}</b>
                    </router-link>
                  </div>
                  <div class="cases-column cases-column2">
                    {{ getDate(single_case.last_visited) }}
                  </div>
                  <div class="cases-column cases-column3">
                    <a href="#" v-if="!getPredmetVoditelj(single_case)">N/A</a>
                    <router-link v-else :to="'/osobe/law/' + getPredmetVoditelj(single_case).uid">{{
                      getPredmetVoditelj(single_case).name
                    }}</router-link>
                  </div>
                  <div class="cases-column cases-column4">
                    <span>
                      <router-link :to="'projects/' + single_case.group_url + '/'">{{ single_case.name }}
                      </router-link>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="analitika section">
          <div class="section-title analitika-title">Analitika
            <div class="analitika-dropdown">
              <select id="search-group">
                <option value="prihodi">Prihodi</option>
                <option value="rashodi">Rashodi</option>
              </select>
              <img
                class="calendar-arrow"
                src="@/assets/img/strelica_dupla.svg"
              />
            </div>
          </div>
          <div class="analitika-graf">
            <img src="@/assets/img/analitika.jpg"/>
          </div>
        </div> -->
          <div class="mini-column-wrapper">
            <div class="row-column hc">
              <KalendarEventsSection :key="refreshKey + 1" @taskIzvrsen="refreshEvents" @dontRefresh="catchIsEmitting"
                :event_type="$t('page_1.row_4.box_1.title')" :event_data="all_events.filter((event) => event.uid_event_type == 4)
                  " />
            </div>
            <div class="row-column hc">
              <KalendarEventsSection :key="refreshKey + 2" @taskIzvrsen="refreshEvents" @dontRefresh="catchIsEmitting"
                :event_type="$t('page_1.row_4.box_2.title')" :event_data="all_events.filter((event) => event.uid_event_type == 2)
                  " />
            </div>
          </div>
        </div>
        <div class="home-second-column hc">
          <KalendarEventsSection :key="refreshKey + 3" @taskIzvrsen="refreshEvents" @dontRefresh="catchIsEmitting"
            :event_type="$t('page_1.row_3.box_2.title')" :event_data="all_events.filter((event) => event.uid_event_type == 1)
              " />
          <KalendarEventsSection :key="refreshKey + 4" @taskIzvrsen="refreshEvents" @dontRefresh="catchIsEmitting"
            :event_type="$t('page_1.row_4.box_3.title')" :event_data="all_events.filter((event) => event.uid_event_type == 3)
              " />
          <!-- <div class="posljednja-aktivnost section">
          <div class="section-title">Posljednja aktivnost</div>
            <div class="case-aktivnost-clan">
              <div class="aktivnost-dot indikator i-g"></div>
              <div class="case-team-member-img case-team-member1"></div>
              <div class="case-aktivnost-txts">
                <div class="case-aktivnost-txt">
                  <b>Marko M.</b> dodao je novi zadatak<span class="role"
                    >prije 5 minuta</span
                  >
                </div>
              </div>
              <div class="furher-arrow">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="17"
                  viewBox="0 0 10 17"
                >
                  <g>
                    <g>
                      <path
                        fill="#9595ad"
                        d="M9.606 9.121l-8.233 7.66a.684.684 0 0 1-.979 0 .71.71 0 0 1 0-.994l7.737-7.198L.394 1.391a.71.71 0 0 1 0-.994.684.684 0 0 1 .979 0l8.233 7.66a.7.7 0 0 1 .196.532.7.7 0 0 1-.196.532z"
                      />
                    </g>
                  </g>
                </svg>
              </div>
            </div> 
            <div class="case-aktivnost-clan">
              <div class="aktivnost-dot indikator i-g"></div>
              <div class="case-team-member-img case-team-member2"></div>
              <div class="case-aktivnost-txts">
                <div class="case-aktivnost-txt">
                  <b>Suzana C.</b> dodala je novi zadatak<span class="role"
                    >prije 1 sat</span
                  >
                </div>
              </div>
              <div class="furher-arrow">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="17"
                  viewBox="0 0 10 17"
                >
                  <g>
                    <g>
                      <path
                        fill="#9595ad"
                        d="M9.606 9.121l-8.233 7.66a.684.684 0 0 1-.979 0 .71.71 0 0 1 0-.994l7.737-7.198L.394 1.391a.71.71 0 0 1 0-.994.684.684 0 0 1 .979 0l8.233 7.66a.7.7 0 0 1 .196.532.7.7 0 0 1-.196.532z"
                      />
                    </g>
                  </g>
                </svg>
              </div>
            </div> 
            <div class="case-aktivnost-clan">
              <div class="aktivnost-dot indikator"></div>
              <div class="case-team-member-img case-team-member3"></div>
              <div class="case-aktivnost-txts">
                <div class="case-aktivnost-txt">
                  <b>Dmitar T.</b> dodao je novi račun<span class="role"
                    >22.11.2020 16:40</span
                  >
                </div>
              </div>
              <div class="furher-arrow">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="17"
                  viewBox="0 0 10 17"
                >
                  <g>
                    <g>
                      <path
                        fill="#9595ad"
                        d="M9.606 9.121l-8.233 7.66a.684.684 0 0 1-.979 0 .71.71 0 0 1 0-.994l7.737-7.198L.394 1.391a.71.71 0 0 1 0-.994.684.684 0 0 1 .979 0l8.233 7.66a.7.7 0 0 1 .196.532.7.7 0 0 1-.196.532z"
                      />
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            <div class="case-aktivnost-clan">
              <div class="aktivnost-dot indikator"></div>
              <div class="case-team-member-img case-team-member3"></div>
              <div class="case-aktivnost-txts">
                <div class="case-aktivnost-txt">
                  <b>Dmitar T.</b> riješio je zadatak<span class="role"
                    >22.11.2020 19:20</span
                  >
                </div>
              </div>
              <div class="furher-arrow">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="17"
                  viewBox="0 0 10 17"
                >
                  <g>
                    <g>
                      <path
                        fill="#9595ad"
                        d="M9.606 9.121l-8.233 7.66a.684.684 0 0 1-.979 0 .71.71 0 0 1 0-.994l7.737-7.198L.394 1.391a.71.71 0 0 1 0-.994.684.684 0 0 1 .979 0l8.233 7.66a.7.7 0 0 1 .196.532.7.7 0 0 1-.196.532z"
                      />
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            <div class="case-aktivnost-clan">
              <div class="aktivnost-dot indikator"></div>
              <div class="case-team-member-img case-team-member3"></div>
              <div class="case-aktivnost-txts">
                <div class="case-aktivnost-txt">
                  <b>Dmitar T.</b> dodao je novi dokument<span class="role"
                    >21.11.2020 21:30</span
                  >
                </div>
              </div>
              <div class="furher-arrow">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="17"
                  viewBox="0 0 10 17"
                >
                  <g>
                    <g>
                      <path
                        fill="#9595ad"
                        d="M9.606 9.121l-8.233 7.66a.684.684 0 0 1-.979 0 .71.71 0 0 1 0-.994l7.737-7.198L.394 1.391a.71.71 0 0 1 0-.994.684.684 0 0 1 .979 0l8.233 7.66a.7.7 0 0 1 .196.532.7.7 0 0 1-.196.532z"
                      />
                    </g>
                  </g>
                </svg>
              </div>
            </div>
        </div> -->
        </div>
      </div>
      <div class="home-third-column">
        <!-- <div class="case-predmet-right-rightpt"> -->
        <MiniCalendar ref="mini_kalendar" />
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import KalendarEventsSection from "@/components/calendarComponents/KalendarEventsSection.vue";
import { getTokenRedirect } from "@/services/auth/redirectLogin";
import auth from "@/services/auth";
import MiniCalendar from "@/components/calendarComponents/MiniCalendar.vue";
import ms_calendar from "@/apiCallers/promise_handler_db/calendarSharepoint";
import person from "@/apiCallers/promise_handler_db/person";
import { refreshLogoutTimer } from "@/plugins/timer.js"
import moment from "moment";
import admin from "@/apiCallers/promise_handler_db/admin.js"
import gsap from 'gsap'

// import osobe from "@/apiCallers/promise_handler_db/osobe_pr";
export default {
  components: { MiniCalendar, KalendarEventsSection },
  data() {
    return {
      accessToken: "",
      all_events: [],
      bulletin_array: [{ text: this.$t('page_1.row_2.no_active') }],
      nema_oglasa: true,
      bulletin_cntr: 0,
      homepage_cases: [],
      homepage_projects: [],
      row_analytics: {
        active_cases: 0,
        archived_cases: 0,
        important_events: 0,
        upcoming_events: 0,
        active_projects: 0,
        archived_projects: 0,
      },
      fetching: true,
      is_emitting: false,
      sioVar: {
        type: {},
        required: false,
        default: null,
      },
      lawyer_id: null,
      refreshKey: 0,
      active_predmeti: true,
      // all_pers: [],
    };
  },
  watch: {
    sioVar: function () {
      if (this.sioVar != null) {
        this.sioVar.socket.on("update task", async () => {
          if (!this.is_emitting) {
            this.refreshEvents();
            this.refreshAnalytics();
          }
        });
      }
    },
    "$store.state.sioVar": function () {
      if (this.$store.state.sioVar != null) {
        this.sioVar = this.$store.state.sioVar
      }
    }
  },
  async created() {
    this.accessToken = this.$store.state.aToken

    var full_user_data = await person.getSelf(this.accessToken);
    // console.log(full_user_data)
    this.lawyer_id = full_user_data.data.uid;
    var tmp_cases = full_user_data.data.case_activity.map(p => {
      p.predmet.last_visited = p.timestamp;
      return p.predmet;
    });
    this.homepage_cases = tmp_cases;
    this.homepage_projects = full_user_data.data.project_activity.map(p => {
      p.project.last_visited = p.timestamp;
      return p.project;
    });
    this.fetching = false;
    await ms_calendar
      .getPersonEvents(this.accessToken, this.lawyer_id)
      .then((resp) => {
        this.all_events = resp.data;
        console.log(this.all_events.filter((event) => event.uid_event_type == 1));
      });
    this.refreshAnalytics();

    await admin.getBulletinBoardValid().then((resp) => {
      if (resp.data.length > 0) {
        this.bulletin_array = resp.data
        this.nema_oglasa = false;
      }
    })
    // predmet_hand
    //   .getAll(this.accessToken, 1, 0, 0, 4, null, null, false)
    //   .then((response) => {
    //     this.fetching=false;
    //     console.log(response.data.full_case_list);
    //     this.homepage_cases = response.data.full_case_list;
    //     //table return animation
    //     // gsap.to(".responstable", 0.5, { opacity: 1, x: 0 });
    //   });
    this.sioVar = this.$store.state.sioVar
  },
  methods: {
    checkUserAllowedModules: function (mod_id) {
      return this.$store.state.logged_in_user.user_role.allowed_modules.includes(mod_id)
    },
    getPredmetVoditelj(single_case) {
      console.log(single_case);
      const voditelj = single_case.connect_project_odvjetnik.find((v) => v.id_status == 1);
      return voditelj ? { uid: voditelj.odvjetnik.uid, name: `${voditelj.odvjetnik.ime} ${voditelj.odvjetnik.prezime}` } : false
    },
    fullLogout() {
      auth.clearLocal();
      auth.logout();
      this.$router.push({ path: "/login" });
    },
    refreshAnalytics() {
      person.getSelfAnalytics(this.accessToken).then((resp) => {
        this.row_analytics = resp.data
      });
    },
    getDate(fullDateTime) {
      return moment(fullDateTime).format("DD.MM.YYYY HH:mm:ss");
    },
    catchIsEmitting() {
      this.is_emitting = true;
    },
    refreshEvents(event) {
      this.all_events = this.all_events.filter((ev) => ev != event);
      ms_calendar
        .getPersonEvents(this.accessToken, this.lawyer_id)
        .then((resp) => {
          this.all_events = resp.data;
          this.refreshKey++;
        });
      this.is_emitting = false;
    },
    nextOglas() {
      // gsap.to('.next-message', 0, {display:'block'})
      gsap.to('.moving-text-wrapper', 0.25, { marginLeft: '-5%', marginRight: "5%", opacity: '0' })
      setTimeout(() => {
        if (this.bulletin_cntr + 1 >= this.bulletin_array.length) {
          this.bulletin_cntr = 0
        } else {
          this.bulletin_cntr++;
        }
        gsap.fromTo('.moving-text-wrapper', 0.25, { marginLeft: '5%', marginRight: "-5%" }, { marginLeft: 0, marginRight: 0, opacity: 1 });
      }, 500);
    },
    prevOglas() {
      gsap.to('.moving-text-wrapper', 0.25, { marginLeft: '5%', marginRight: "-5%", opacity: '0' })
      setTimeout(() => {
        if (this.bulletin_cntr == 0) {
          this.bulletin_cntr = this.bulletin_array.length - 1;
        } else {
          this.bulletin_cntr--;
        }
        gsap.fromTo('.moving-text-wrapper', 0.25, { marginLeft: '-5%', marginRight: "5%" }, { marginLeft: 0, marginRight: 0, opacity: 1 });
      }, 500);
    },
    convertDate(dt) {
      return moment(dt).format("DD.MM.YYYY.")
    },
    async getAttachment(attach_id, file_name) {
      this.accessToken = this.$store.state.aToken
      await admin.getOglasnaAttachent(this.accessToken, attach_id).then((resp) => {
        //pripremanje download linka
        var link = document.createElement("a");
        link.setAttribute("href", resp.data.webUrl);
        link.setAttribute("target", "_blank");
        link.setAttribute("download", file_name);
        link.click();
      })
    },
    returnFileType(file_name) {
      var idx_ext = file_name.split(".").length - 1;
      var extension = file_name.split(".")[idx_ext].toLowerCase();

      var return_val = require("@/assets/img/doc_icon.svg");
      switch (extension) {
        case "docx":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "dotx":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "dotm":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "pptx":
          return_val = require("@/assets/img/ppt-icon.png");
          break;
        case "ppt":
          return_val = require("@/assets/img/ppt-icon.png");
          break;
        case "doc":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "pdf":
          return_val = require("@/assets/img/pdf_icon.svg");
          break;
        case "csv":
          return_val = require("@/assets/img/xls_icon.svg");
          break;
        case "xlsx":
          return_val = require("@/assets/img/xls_icon.svg");
          break;
        case "jpg":
          return_val = require("@/assets/img/jpg_icon.svg");
          break;
        case "jpeg":
          return_val = require("@/assets/img/jpg_icon.svg");
          break;
        case "png":
          return_val = require("@/assets/img/png_icon.svg");
          break;
        case "folder":
          return_val = require("@/assets/img/folder_yellow.svg");
          break;
        default:
          return_val = require("@/assets/img/dat_icon.svg");
          break;
      }
      return return_val;
    },
  },
  mounted() {
    refreshLogoutTimer()

    // this.all_events = this.$refs.mini_kalendar.$data

    // osobe.getAllOsobe().then((resp) => {
    //   console.log(resp.data);
    //   resp.data.forEach((p) => {
    //     this.all_pers.push({
    //       link: p.url,
    //       value: p.ime + " " + p.prezime,
    //       uloga: p.uloga,
    //       email: p.email,
    //     });
    //   });
    // });
    this.$store.state.paginacija.title = this.$t('breadcrumbs.index')
  },
};
</script>

<style></style>